export default __webpack_public_path__ + "static/fourthStep-190728df3024cea96fbd6513afb8b62e.png";